// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cid-modules__cid___P5SsW{text-transform:none;color:#1fcbff}", "",{"version":3,"sources":["webpack://./src/components/link/cid.modules.scss"],"names":[],"mappings":"AAAA,0BACE,mBAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cid": "cid-modules__cid___P5SsW"
};
export default ___CSS_LOADER_EXPORT___;
